import React from 'react';
//import axios from 'axios';
import { user_token } from '../../../../services/Auth';

import {agent} from '../../../../services/api';
let apiAgent = new agent();

export default class GetUserID extends React.Component {
  state = {
    nome: [],
  }

  componentDidMount = async () => {
    await apiAgent.getUser(this.props.user_id)
      .then(res => {
        const nome = res.data;
        console.log(this.props.user_id);
        this.setState({ nome });
      })
  }

  render() {
    return (
      <ul>
        { this.state.nome.map(person => 
          <span>{person.numericID}- {person.name}</span>)}
      </ul>
    )
  }
}